import { creators } from '@/mocks/creators';

export default function CreatorSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            优秀创作者风采
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            他们在快猫实现了创作梦想，下一个就是你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {creators.map((creator, index) => (
            <div
              key={index}
              className="group p-6 rounded-lg bg-background-100 border border-background-200/60 hover:border-accent-200 transition-all duration-300 text-center"
            >
              <div className="w-20 h-20 mx-auto mb-4 rounded-full overflow-hidden border-2 border-accent-200 group-hover:border-accent-500 transition-colors">
                <img
                  src={creator.avatar}
                  alt={creator.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-1">
                {creator.name}
              </h3>
              <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-2">
                {creator.category}
              </span>
              <p className="text-xs text-foreground-500 mb-3">
                {creator.description}
              </p>
              <div className="flex items-center justify-center gap-1.5 text-xs">
                <span className="text-accent-600 font-semibold">{creator.followers}</span>
                <span className="text-foreground-400">粉丝</span>
              </div>
              <div className="mt-2 pt-3 border-t border-background-200/60">
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {creator.achievement}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}